import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import HeroSection from "../components/StrategicAllies/HeroSection";
import DrStrategic from "../components/StrategicAllies/DrStrategic";
import CorsanoPartner from "../components/StrategicAllies/CorsanoPartner";
import InariPartner from "../components/StrategicAllies/InariPartner";
import FisioPartner from "../components/StrategicAllies/FisioPartner";
import LilyPartner from "../components/StrategicAllies/LilyPartner";

function StrategicAllies() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Aliados estratégicos | NovaXFit</title>
        <meta
          name="description"
          content="Conoce los aliados estratégicos de NovaXFit y los beneficios disponibles para usuarios con membresía activa en La Libertad, provincia de Santa Elena."
        />
        <link rel="canonical" href="https://novaxfit.com/nuestros-aliados" />
      </Helmet>

      <div>
        <HeroSection />
        <FisioPartner />
        <CorsanoPartner />
        <LilyPartner />
        <InariPartner />
        <DrStrategic />
      </div>
    </>
  );
}

export default StrategicAllies;